import { render, staticRenderFns } from "./LegalDocumentContent_tNgGHe.vue?vue&type=template&id=0489b4ca&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_tNgGHe.vue?vue&type=style&index=0&id=0489b4ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489b4ca",
  null
  
)

export default component.exports